import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Direction } from '../model/direction';

@Injectable({
    providedIn: 'root'
  })
  export class DirectionService{
  

    constructor(private _restClientService : RestClientService) { }
    
    
    getAllDirections() {
      return this._restClientService.load<Direction[]>('direction/directions');
    }
      
    getDirectionById(directionId){
      return this._restClientService.load<Direction>('direction/get/'+directionId);
    }
    
    putDirection(direction) {
      return  this._restClientService.put<Direction>(`direction/update`, direction);
    
    }
    
    postDirection(direction) {
      return  this._restClientService.save<Direction>('direction/add', direction);
    }
    
  

  


}      

    